import { tryGetAuthenticatedUser } from "@roman/shared/store/auth.store";
import type { UserBase } from "@roman/shared/types/UserBase";
import type { Platform } from "@roman/shared/utils/platform";

const platformToOwp = {
  pc: "ed9078e3-d3ee-4d57-9b27-e2944d0d5f64",
  android: "5e36a16d-ce9a-4d69-b530-30a3f28bf894",
  ios: "0d54f82a-fac1-40dd-b905-2130c5164dad",
} as const satisfies Record<Platform, string>;

const getHost = (env: "dev" | "prod") => {
  if (env === "dev") return "ow.stg.skyflag.jp";
  return "ow.skyflag.jp";
};

const getOwp = (platform: Platform, env: "dev" | "prod") => {
  if (env === "dev") return "99b7890b-aad5-414a-8fd2-97331e46d33d";
  return platformToOwp[platform];
};

type Spram1 = "pointpage" | "campaignbanner" | "GN";

type RedeemPointsLinkInput = {
  platform: Platform;
  suid: UserBase["id"];
  spram1?: Spram1;
  env: "dev" | "prod";
};

const getLink = ({ platform, suid, spram1, env }: RedeemPointsLinkInput) => {
  const host = getHost(env);
  const url = new URL(`https://${host}/ad/p/ow/index`);
  const _owp = getOwp(platform, env);
  url.searchParams.set("_owp", _owp);
  url.searchParams.set("suid", suid);
  if (spram1) url.searchParams.set("spram1", spram1);
  return url.toString();
};

export type UseRedeemPointsLinkInput = {
  spram1?: Spram1;
};

type UseRedeemPointsLinkOutput = {
  onClick: () => void;
};

export const useRedeemPointsLinkBase = (
  input: UseRedeemPointsLinkInput,
  env: "dev" | "prod",
  platform: "pc" | "android" | "ios",
  navigate: (path: string) => void,
  openBrowser: (url: string) => void,
): UseRedeemPointsLinkOutput => {
  const { spram1 } = input;
  const user = tryGetAuthenticatedUser();

  if (!user) return { onClick: () => navigate("/login") };
  if (!user.isSMSVerified) return { onClick: () => navigate("/sms-registration") };
  const url = getLink({ platform, suid: user.id, spram1, env });
  return { onClick: () => openBrowser(url) };
};
